import React, {
  InputHTMLAttributes,
  useState,
  ChangeEvent,
  useEffect,
} from 'react';
import classNames from 'classnames';
import Checkbox from '@material-ui/core/Checkbox';
import CheckRounded from '@material-ui/icons/CheckRounded';

import styles from './CheckboxWidget.module.scss';

export type Props = InputHTMLAttributes<HTMLInputElement> & {
  hasError?: boolean;
  classes?: {
    inputContainer?: string;
    inputRoot?: string;
    icon?: string;
    checkedIcon?: string;
  };
};

export default function CheckboxWidget({
  hasError,
  classes,
  onChange,
  checked,
  ...props
}: Props): JSX.Element {
  const [isChecked, setIsChecked] = useState(!!checked);

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    onChange?.(event);

    if (!event.isPropagationStopped()) {
      setIsChecked(isChecked => !isChecked);
    }
  }

  useEffect(() => {
    setIsChecked(!!checked);
  }, [checked]);

  return (
    <Checkbox
      color={'default'}
      disableRipple
      disableTouchRipple
      disableFocusRipple
      className={classNames(styles.container, classes?.inputContainer)}
      classes={{ root: classNames(styles.root, classes?.inputRoot) }}
      icon={
        <span
          className={classNames(
            styles.boxStyle,
            classes?.icon,
            hasError && styles.errorBoxStyle
          )}
        />
      }
      checkedIcon={
        <span
          className={classNames(
            styles.boxStyle,
            classes?.icon,
            classes?.checkedIcon,
            hasError && styles.errorBoxStyle
          )}
        >
          <CheckRounded />
        </span>
      }
      checked={isChecked}
      onChange={handleChange}
      inputProps={{ ...props }}
    />
  );
}
